import { Helmet } from 'react-helmet';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardHeader from '../DashboardHome/DashboardHeader/DashboardHeader';
import DashboardCOMWidgetsList from './DashboardCOMWidgetsList/DashboardCOMWidgetsList';
import DashboardCOMProspectsTable from './DashboardCOMProspectsTable/DashboardCOMProspectsTable';
import DashboardCOMLastMonths from './DashboardCOMLastMonths/DashboardCOMLastMonths';
import { useQuery } from 'react-query';
import {
  DASHBOARD_COM_WIDGET_QUERY_KEY,
  queryDashboardCOMWidget,
} from './DashboardCOMWidgetsList/DashboardCOMWidgetsList.query';

export default () => {
  const { data } = useQuery(DASHBOARD_COM_WIDGET_QUERY_KEY, () => queryDashboardCOMWidget());

  return (
    <>
      <Helmet>
        <title>Tableau de bord</title>
      </Helmet>
      <DashboardLayout>
        <DashboardHeader />
        <DashboardCOMWidgetsList {...{ data }} />
        <section className="dashboard__main-row">
          <DashboardCOMProspectsTable />
          <DashboardCOMLastMonths {...{ data }} />
        </section>
      </DashboardLayout>
    </>
  );
};
